"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AjvErrorV3 () {
        return AjvErrorV3;
    },
    get NcErrorV3 () {
        return NcErrorV3;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _NcErrorV1 = require("./NcErrorV1");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
let AjvErrorV3 = class AjvErrorV3 extends _nocodbsdk.NcBaseErrorv2 {
    constructor(param){
        super(param.message, 400, _nocodbsdk.NcErrorType.ERR_INVALID_REQUEST_BODY, {
            details: param.errors
        });
        this.errors = param.errors;
        this.humanReadableError = param.humanReadableError || false;
    }
};
let NcErrorV3 = class NcErrorV3 extends _NcErrorV1.NcErrorV1 {
    ajvValidationError(param) {
        throw new AjvErrorV3(param);
    }
    invalidRequestBody(message) {
        throw this.errorCodex.generateError(_nocodbsdk.NcErrorType.ERR_INVALID_REQUEST_BODY, {
            params: message
        });
    }
    teamNotFound(id, args) {
        throw this.errorCodex.generateError(_nocodbsdk.NcErrorType.ERR_TEAM_NOT_FOUND, _extends({
            params: id
        }, args));
    }
    constructor(){
        super();
        this.errorCodex.setErrorCodexes({
            [_nocodbsdk.NcErrorType.ERR_INVALID_FILTER]: {
                message: (message)=>`Invalid filter expression: ${message}`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_BASE_NOT_FOUND]: {
                message: (id)=>`Base '${id}' not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_TABLE_NOT_FOUND]: {
                message: (id)=>`Table '${id}' not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_VIEW_NOT_FOUND]: {
                message: (id)=>`View '${id}' not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_FIELD_NOT_FOUND]: {
                message: (id)=>`Field ${id} not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_TEAM_NOT_FOUND]: {
                message: (id)=>`Team '${id}' not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_USER_NOT_FOUND]: {
                message: (id)=>`User '${id}' not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_EXTENSION_NOT_FOUND]: {
                message: (id)=>`Extension '${id}' not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_DASHBOARD_NOT_FOUND]: {
                message: (id)=>`Dashboard '${id}' not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_WORKFLOW_NOT_FOUND]: {
                message: (id)=>`Workflow '${id}' not found`,
                code: 422
            },
            [_nocodbsdk.NcErrorType.ERR_SCRIPT_NOT_FOUND]: {
                message: (id)=>`Script '${id}' not found`,
                code: 422
            }
        });
    }
};
